import styled from 'styled-components'

const StyledDescriptorImg = styled.img`
  margin-left: 6px;
  height: 20px;
`

export default StyledDescriptorImg
